<template>
  <div id="app">
    <AppHeader></AppHeader>

    <main><router-view /></main>
    <b-loading
      :is-full-page="true"
      :active.sync="loader.isLoading"
      :can-cancel="false"
    >
      <div class="loading-icon">
        <p class="loader-text">{{ loader.loaderText }}</p>
      </div>
    </b-loading>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AppHeader from './components/header/Header';
import AppFooter from './components/footer/Footer';
import { setTimeout } from 'timers';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  created: function() {
    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(function() {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.logOut();
        }
        throw err;
      });
    });
    let route = window.location.pathname;
    const token =
      window.location.search && window.location.search.split('token=').length
        ? window.location.search.split('token=')[1]
        : '';
    if (
      !!token &&
      !route.includes('/account/documents') &&
      !route.includes('rollover')
    ) {
      this.toggleLoader({
        loaderText: 'Please wait while we retrieve your information.'
      });
      this.checkSession({
        token: token,
        currentRoutePath: route
      })
        .then(() => {
          this.toggleLoader();
        })
        .catch(() => {
          if (token && !this.quoteResponse) {
            this.$snackbar.open({
              type: 'is-danger',
              message: `We were unable to retrieve your quote. Please click the 'Start a new quote' button to continue.`,
              position: 'is-bottom',
              duration: 3500
            });
            this.toggleLoader();
            this.$router.push('/');
            setTimeout(() => {
              let container = document.getElementById('home-page-section');
              container.scrollIntoView({ behavior: 'smooth' });
            }, 100);
          } else {
            this.toggleLoader();
          }
        });
    }
  },
  computed: {
    ...mapGetters(['activeNav', 'activeUserNav', 'quoteResponse', 'loader'])
  },
  methods: {
    ...mapActions(['toggleNav', 'toggleUserNav', 'logOut', 'checkSession']),
    ...mapMutations(['toggleLoader'])
  },
  watch: {
    $route() {
      if (this.activeNav) {
        this.toggleNav(true);
      }
      if (this.activeUserNav) {
        this.toggleUserNav(true);
      }
    }
  }
};
</script>

<style lang="scss">
@import './assets/sass/theme.scss';
.loading-overlay {
  .loading-background {
    background: rgba(255, 255, 255, 0.7);
  }
}
.loader-text {
  margin-top: 150px;
  color: $abbey;
  font-weight: bold;
  padding: 10px;
  text-align: center;
}
</style>
